import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "", as: Tag = "span" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      <Tag>{children}</Tag>
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`font-mono text-[11px] uppercase tracking-[0.3em] text-brand-red ${className}`}>
    {children}
  </span>
);
